/* Component Dependencies */
var findMemberNumberTemplate = require('templates/findMemberNumber.hbs');
var AriesComponent = require('libs/aries-component');
var emailValidationHandler = require('utils/emailValidation.js');


AriesComponent.create({
  type: 'findMemberNumber',
  template: {
    'findMemberNumber': findMemberNumberTemplate
  },

  events: {
    'click .js-btn-submit': 'errorValidation'
  },
  
  errorValidation: function _errorValidation(e){
    var firstName = $('#field-first-name').val().trim();
    var lastName = $('#field-last-name').val().trim();
    var emailAddress = $('.js-emailValidation').val().trim();
    var isEmailTrue = emailValidationHandler.emailValidation(emailAddress, 'all');
    $('#errorValidation, .firstNameValidation, .lastNameValidation, .emailAddressValidation, .emailAddressValidationRequired').addClass('l-display-none').removeClass('display-block');
    $('.js-emailValidation, .js-lastName, .js-firstName').removeClass('is-error');
    if(!firstName){
      $('#errorValidation .firstNameValidation').removeClass('l-display-none').addClass('display-block');
      $('.js-firstName').addClass('is-error');
    }
    if(!lastName){
      $('#errorValidation .lastNameValidation').removeClass('l-display-none').addClass('display-block');
      $('.js-lastName').addClass('is-error');
    } 
    if(!isEmailTrue || !emailAddress){
      if(!isEmailTrue){
        $('#errorValidation .emailAddressValidation').removeClass('l-display-none').addClass('display-block');

      }
      else{
        $('#errorValidation .emailAddressValidationRequired').removeClass('l-display-none').addClass('display-block');
      }
      $('.js-emailValidation').addClass('is-error');
    }
    if(!firstName || !lastName || !isEmailTrue || !emailAddress){
      $('#errorValidation').removeClass('l-display-none');
      e.preventDefault(); 
    }
				if($('.tile-error-messages')) { 
										$('.tile-error-messages').addClass('l-display-none');
				}
  }
});
